/**
 * THIS FILE WAS GENERATED BY RUNNING: gulp jsControllers
 * DO NOT MODIFY DIRECTLY. INSTEAD RUN the gulp command or modify /fe/tasks/helpers/controllersFileTemplate.js
 * 
 * This is a file containing a dictionary of all our js controllers and their templates
 */
define('controllers',['require','exports','module','controllers/404','controllers/about','controllers/accountsummary','controllers/ach_schedule','controllers/admin/content','controllers/admin/customercontacts','controllers/admin/customers','controllers/admin/galileo','controllers/admin/memberagreement','controllers/admin/users','controllers/book','controllers/callcenter/auditreservations','controllers/callcenter/email','controllers/cancelvacation','controllers/changeusername','controllers/contact','controllers/crm','controllers/destinations','controllers/editdestination','controllers/edithotel','controllers/edithotelphotos','controllers/edithotelroomsanddescriptions','controllers/editrooms','controllers/emailcampaign','controllers/emailcampaignanalytics','controllers/empowered','controllers/enroll','controllers/enrollmentbonus','controllers/executive/hotelinterest','controllers/externalaccountinsert','controllers/faq','controllers/financialaccount','controllers/financialinfo','controllers/finddestination','controllers/findhotel','controllers/hits','controllers/home','controllers/hotel/adestinndetails','controllers/hotelattributes','controllers/hotelcarousel','controllers/hotelcontacts','controllers/hoteldetailssearch','controllers/hotelinfo','controllers/hotelinvoices','controllers/hotelispr','controllers/hotelnewsearch','controllers/hotelportal','controllers/hr','controllers/invoices','controllers/ispr','controllers/latestevents','controllers/login','controllers/mainmenu','controllers/mainslideshow','controllers/mapsearch','controllers/members','controllers/membersearch','controllers/myaccount','controllers/myaccountlinks','controllers/myaccountpreferences','controllers/news','controllers/newsedit','controllers/notoperatingasuserwarning','controllers/occupancyrestriction','controllers/passwordstrength','controllers/pendingreservations','controllers/perfectsaver','controllers/privacypolicy','controllers/recoverpassword','controllers/referafriend','controllers/refund','controllers/registration','controllers/registrationprocess','controllers/resethotelpassword','controllers/retargetingpixel','controllers/reviewacceptedvacations','controllers/roomselection','controllers/searchcontrol','controllers/security','controllers/signup','controllers/survey','controllers/tabmanager','controllers/termsofuse','controllers/usermanager','controllers/vacations','controllers/viewmemberenrollmentsteps','controllers/vspcalculator'],function(require, exports, module) {
    'use strict';

    return {
        '404': [require('controllers/404')],
		'about': [require('controllers/about')],
		'accountsummary': [require('controllers/accountsummary')],
		'ach_schedule': [require('controllers/ach_schedule')],
		'admincontent': [require('controllers/admin/content')],
		'admincustomercontacts': [require('controllers/admin/customercontacts')],
		'admincustomers': [require('controllers/admin/customers')],
		'admingalileo': [require('controllers/admin/galileo')],
		'adminmemberagreement': [require('controllers/admin/memberagreement')],
		'adminusers': [require('controllers/admin/users')],
		'book': [require('controllers/book')],
		'callcenterauditreservations': [require('controllers/callcenter/auditreservations')],
		'callcenteremail': [require('controllers/callcenter/email')],
		'cancelvacation': [require('controllers/cancelvacation')],
		'changeusername': [require('controllers/changeusername')],
		'contact': [require('controllers/contact')],
		'crm': [require('controllers/crm')],
		'destinations': [require('controllers/destinations')],
		'editdestination': [require('controllers/editdestination')],
		'edithotel': [require('controllers/edithotel')],
		'edithotelphotos': [require('controllers/edithotelphotos')],
		'edithotelroomsanddescriptions': [require('controllers/edithotelroomsanddescriptions')],
		'editrooms': [require('controllers/editrooms')],
		'emailcampaign': [require('controllers/emailcampaign')],
		'emailcampaignanalytics': [require('controllers/emailcampaignanalytics')],
		'empowered': [require('controllers/empowered')],
		'enroll': [require('controllers/enroll')],
		'enrollmentbonus': [require('controllers/enrollmentbonus')],
		'executivehotelinterest': [require('controllers/executive/hotelinterest')],
		'externalaccountinsert': [require('controllers/externalaccountinsert')],
		'faq': [require('controllers/faq')],
		'financialaccount': [require('controllers/financialaccount')],
		'financialinfo': [require('controllers/financialinfo')],
		'finddestination': [require('controllers/finddestination')],
		'findhotel': [require('controllers/findhotel')],
		'hits': [require('controllers/hits')],
		'home': [require('controllers/home')],
		'hoteladestinndetails': [require('controllers/hotel/adestinndetails')],
		'hotelattributes': [require('controllers/hotelattributes')],
		'hotelcarousel': [require('controllers/hotelcarousel')],
		'hotelcontacts': [require('controllers/hotelcontacts')],
		'hoteldetailssearch': [require('controllers/hoteldetailssearch')],
		'hotelinfo': [require('controllers/hotelinfo')],
		'hotelinvoices': [require('controllers/hotelinvoices')],
		'hotelispr': [require('controllers/hotelispr')],
		'hotelnewsearch': [require('controllers/hotelnewsearch')],
		'hotelportal': [require('controllers/hotelportal')],
		'hr': [require('controllers/hr')],
		'invoices': [require('controllers/invoices')],
		'ispr': [require('controllers/ispr')],
		'latestevents': [require('controllers/latestevents')],
		'login': [require('controllers/login')],
		'mainmenu': [require('controllers/mainmenu')],
		'mainslideshow': [require('controllers/mainslideshow')],
		'mapsearch': [require('controllers/mapsearch')],
		'members': [require('controllers/members')],
		'membersearch': [require('controllers/membersearch')],
		'myaccount': [require('controllers/myaccount')],
		'myaccountlinks': [require('controllers/myaccountlinks')],
		'myaccountpreferences': [require('controllers/myaccountpreferences')],
		'news': [require('controllers/news')],
		'newsedit': [require('controllers/newsedit')],
		'notoperatingasuserwarning': [require('controllers/notoperatingasuserwarning')],
		'occupancyrestriction': [require('controllers/occupancyrestriction')],
		'passwordstrength': [require('controllers/passwordstrength')],
		'pendingreservations': [require('controllers/pendingreservations')],
		'perfectsaver': [require('controllers/perfectsaver')],
		'privacypolicy': [require('controllers/privacypolicy')],
		'recoverpassword': [require('controllers/recoverpassword')],
		'referafriend': [require('controllers/referafriend')],
		'refund': [require('controllers/refund')],
		'registration': [require('controllers/registration')],
		'registrationprocess': [require('controllers/registrationprocess')],
		'resethotelpassword': [require('controllers/resethotelpassword')],
		'retargetingpixel': [require('controllers/retargetingpixel')],
		'reviewacceptedvacations': [require('controllers/reviewacceptedvacations')],
		'roomselection': [require('controllers/roomselection')],
		'searchcontrol': [require('controllers/searchcontrol')],
		'security': [require('controllers/security')],
		'signup': [require('controllers/signup')],
		'survey': [require('controllers/survey')],
		'tabmanager': [require('controllers/tabmanager')],
		'termsofuse': [require('controllers/termsofuse')],
		'usermanager': [require('controllers/usermanager')],
		'vacations': [require('controllers/vacations')],
		'viewmemberenrollmentsteps': [require('controllers/viewmemberenrollmentsteps')],
		'vspcalculator': [require('controllers/vspcalculator')]
    };
});
